export * from "./day.type";
